import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
@Component({
  selector: 'cron-time-picker',
  templateUrl: './cron-time-picker.template.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule
  ]
})
export class TimePickerComponent implements OnInit {
  @Output() public onChange = new EventEmitter();

  @Input() public disabled = false;
  @Input() public model: any = {};
  @Input() public selectClass?: string;
  @Input() public use24HourTime?: boolean;
  @Input() public hideSeconds?: boolean;

  public hours: number[] = [];
  public minutes: number[] = [];
  public seconds: number[] = [];
  public hourTypes: string[] = [];

  public async ngOnInit() {
    this.hours = this.use24HourTime ? this.range(0, 23) : this.range(0, 12);
    this.minutes = this.range(0, 59);
    this.seconds = this.range(0, 59);
    this.hourTypes = ['AM', 'PM'];
  }

  changeEmit() {
    this.onChange.emit();
  }

  private range(start: number, end: number): number[] {
    const length = end - start + 1;
    return Array.apply(undefined, Array(length)).map((_, i) => i + start);
  }
}
